import React, { useState, useEffect, useRef, InputHTMLAttributes } from 'react';
//import './HeaderSort.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { Popover } from 'react-tiny-popover';
import OpenFilter from '../OpenFilter';

function HeaderFilter(props) {
	const {
		filterKey,
		filter,
		filters,
		setFilters,
		openFilter,
		setOpenFilter,
		isFilterActive
	} = props;

	const ref = useRef();

	const handleFilterClick = (e) => {
		e.stopPropagation();
		setOpenFilter(openFilter !== filterKey ? filterKey : null);
	};

	useEffect(() => {
		if (openFilter === filterKey) {
			if (ref.current) {
				(ref.current as HTMLInputElement).focus();
			}
		}
	}, [openFilter, filterKey])

	return (
		<Popover
			isOpen={openFilter === filterKey}
			positions={['bottom', 'top']}
			align={'center'}
			onClickOutside={() => setOpenFilter(null)}
			padding={0}
			content={<OpenFilter
				ref={ref}
				filterKey={filterKey}
				filter={filter}
				filters={filters}
				setFilters={filters => {
					setFilters(filters);
				}}
			/>}
		>
			<div className={`header__filter ${isFilterActive(filter, filterKey) ? 'active' : ''}`} onClick={handleFilterClick}>
				<FontAwesomeIcon icon={faFilter} />
			</div>
		</Popover>
	);
}

export default HeaderFilter;
